<ng-container *ngIf="isTenantIndependentRoute$ | async; else tenantDependentRoute">
  <ng-container [ngSwitch]="section">
    <ng-container *ngSwitchCase="TenantLogoSection.Profile">
      <svg-icon class="menu-icon" key="settings" fontSize="40px"></svg-icon>
    </ng-container>
    <ng-container *ngSwitchCase="TenantLogoSection.Main">
      <div class="d-flex flex-row align-items-center">
        <svg-icon class="menu-icon" key="settings" fontSize="40px"></svg-icon>
        <div class="d-flex flex-column logo-text-container"><span class="general">general</span><span class="settings">settings</span></div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #tenantDependentRoute>
  <ng-container *ngIf="selectedTenant$ | async as selectedTenant; else noTenant">
    <ng-container [ngSwitch]="section">
      <ng-container *ngSwitchCase="TenantLogoSection.Main">
        <ng-container [ngSwitch]="selectedTenant.id">
          <img
            *ngSwitchCase="'b1de658c-5f52-11ed-9b6a-0242ac120002'"
            src="assets/images/osn-plus-uxb-logo.svg"
            width="50"
            height="32"
            alt=""
            data-testid="tenant-logo-main-osn-tv"
          />
          <img
            *ngSwitchCase="'699bd80c-5f54-11ed-9b6a-0242ac120002'"
            src="assets/images/omantel_no_bg.PNG"
            width="66"
            height="42"
            alt=""
            data-testid="tenant-logo-main-omantel"
          />
          <img
            *ngSwitchCase="'575724ce-6ef1-11ed-a1eb-0242ac120002'"
            src="assets/images/osn-plus-uxb-logoTESTpng.png"
            width="80"
            alt=""
            data-testid="tenant-logo-main-osn-test"
          />
          <img
            *ngSwitchCase="'dc2b24d4-9a59-42c4-b553-e337560029b0'"
            src="assets/images/osnplus-logo-white.png"
            width="80"
            alt=""
            data-testid="tenant-logo-main-osn-test"
          />
          <img
            *ngSwitchCase="'36dfaee2-11ca-4b01-9013-5e0e5f6eb3f2'"
            src="assets/images/on_demand_icon.svg"
            width="50"
            alt=""
            data-testid="tenant-logo-main-ondemand"
          />
          <img
            *ngSwitchCase="'9048d702-b470-43ea-808b-babf1df9e9b6'"
            src="assets/images/store_icon.svg"
            width="30"
            alt=""
            data-testid="tenant-logo-main-store"
          />
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="TenantLogoSection.Profile">
        <ng-container [ngSwitch]="selectedTenant.id">
          <div
            *ngSwitchCase="'b1de658c-5f52-11ed-9b6a-0242ac120002'"
            class="icon osn-icon-container mr-2"
            data-testid="tenant-logo-profile-osn-tv"
          >
            <img class="osn-icon" src="assets/images/osn-logo-without-tv.svg" alt="" />
            <img class="tv-icon" src="assets/images/tv.svg" alt="" />
          </div>
          <div
            *ngSwitchCase="'36dfaee2-11ca-4b01-9013-5e0e5f6eb3f2'"
            class="icon osn-icon-container mr-2"
            data-testid="tenant-logo-profile-ondemand"
          >
            <img src="assets/images/on_demand_icon.svg" width="45" height="45" alt="" />
          </div>
          <div
            *ngSwitchCase="'9048d702-b470-43ea-808b-babf1df9e9b6'"
            class="icon osn-icon-container mr-2"
            data-testid="tenant-logo-profile-store"
          >
            <img src="assets/images/store_icon.svg" width="30" height="30" alt="" />
          </div>
          <div
            *ngSwitchCase="'dc2b24d4-9a59-42c4-b553-e337560029b0'"
            class="icon osn-plus-icon-container mr-2"
            data-testid="tenant-logo-profile-osn-plus"
          >
            <img src="assets/images/osnplus-logo-white.png" width="35" alt="" />
          </div>
          <div *ngSwitchCase="'699bd80c-5f54-11ed-9b6a-0242ac120002'" class="icon omantel-icon-container mr-2">
            <img src="assets/images/omantel_no_bg.PNG" width="40" height="30" alt="" data-testid="tenant-logo-profile-omantel" />
          </div>
          <div
            *ngSwitchCase="'575724ce-6ef1-11ed-a1eb-0242ac120002'"
            class="icon osn-icon-container mr-2"
            data-testid="tenant-logo-profile-osn-tv-test"
          >
            <img class="osn-icon" src="assets/images/osn-logo-without-tv.svg" alt="" />
            <img class="tv-icon" src="assets/images/tv.svg" alt="" />
            <p class="osn-test-text">test</p>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #noTenant>
    <ng-container [ngSwitch]="section">
      <ng-container *ngSwitchCase="TenantLogoSection.Main">
        <img src="assets/images/osn-plus-uxb-logo.svg" width="50" height="32" alt="" data-testid="tenant-logo-main-osn-tv" />
      </ng-container>
      <ng-container *ngSwitchCase="TenantLogoSection.Profile">
        <div class="icon osn-icon-container mr-2" data-testid="tenant-logo-profile-osn-tv">
          <img class="osn-icon" src="assets/images/osn-logo-without-tv.svg" alt="" />
          <img class="tv-icon" src="assets/images/tv.svg" alt="" />
        </div>
      </ng-container>
    </ng-container>
  </ng-template>
</ng-template>
